module.exports = __webpack_public_path__ + "files/be29b92f3e4fe4ebb86e7236f360a433.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/image.png
// module id = 1401
// module chunks = 59